import { render, staticRenderFns } from "./ChangeDatatypeTab.vue?vue&type=template&id=005cbbca&"
import script from "./ChangeDatatypeTab.vue?vue&type=script&lang=js&"
export * from "./ChangeDatatypeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports